// Deployed DEV environment (https://vestfrost-dev.datapilots.dk), used by `npm run build:dev`.
// Local `ng serve` keeps using environment.ts, which points redirectUri at localhost:4200.
// redirectUri must match a Cognito "Allowed callback URL" exactly — no trailing slash here —
// and must also be registered as an "Allowed sign-out URL" — logout() reuses it as logout_uri.
export const environment = {
  production: false,
  apiUrl: 'https://vestfrost-dev-api.datapilots.dk',
  auth: {
    issuer:        'https://cognito-idp.eu-central-1.amazonaws.com/eu-central-1_5esOxRWJA',
    hostedUiBase:  'https://vestfrost-dev.auth.eu-central-1.amazoncognito.com',
    clientId:      '3n13icm4ufqdjl2p87m0ipunp7',
    redirectUri:   'https://vestfrost-dev.datapilots.dk',
    scope:         'openid email phone profile',
  },
};
